{
  "placeholder": "Ingresa {fieldName}",
  "email": "Correo electrónico",
  "validEmail": "El correo electrónico debe ser válido",
  "password": "Contraseña",
  "validPassword": "La contraseña debe tener al menos 8 caracteres, incluyendo 1 mayúscula, 1 minúscula, 1 número y 1 carácter especial",
  "passwordsDontMatch": "Las contraseñas no coinciden",
  "newPassword": "Nueva contraseña",
  "confirmPassword": "Confirmar contraseña",
  "confirmPasswordPlaceholder": "Confirma la contraseña",
  "confirmNewPassword": "Confirmar la nueva contraseña",
  "confirmNewPasswordPlaceholder": "Confirma la nueva contraseña",
  "oldPassword": "Contraseña anterior",
  "verificationCode": "Código de verificación",
  "validVerificationCode": "El código de verificación debe tener 6 números",
  "verificationCodeRequired": "El código de verificación es obligatorio",
  "name": "Nombre",
  "surname": "Apellido",
  "telNumber": "Número de teléfono",
  "mobileNumber": "Número de celular",
  "countryRegion": "País / Región",
  "validPhoneNumber": "Ingresa un número de teléfono válido",
  "submit": "Enviar",
  "update": "Actualizar",
  "submitVerificationCode": "Enviar código de verificación",
  "csvInvalid": "Una de estas URL separadas por comas no es válida",
  "selectDatetime": "Seleccionar fecha/hora",
  "asap": "Lo antes posible",
  "selectAddress": "Seleccionar dirección",
  "searchPostcodeOrAddress": "Buscar código ZIP o dirección",
  "filterNicknameOrAddress": "Filtrar por alias o dirección",
  "searchFor": "Buscar {label}",
  "select": "Seleccionar {label}",
  "toPayment": "Ir al pago",
  "addressForm": {
    "addAddress": "Agregar dirección",
    "editAddress": "Editar dirección",
    "labels": {
      "code": "Alias",
      "addressName": "Nombre de la empresa/dirección",
      "address1": "Dirección línea 1",
      "address2": "Dirección línea 2",
      "address3": "Ciudad",
      "address4": "Estado",
      "postcode": "Código postal (ZIP)",
      "notes": "Notas"
    },
    "placeholders": {
      "code": "Ejemplo: Oficina central",
      "addressName": "Ejemplo: Ejemplo Soluciones Inc",
      "address1": "Ejemplo: 123 Example Street",
      "address2": "Ejemplo: Parque de Innovación",
      "address3": "Ejemplo: Nueva York",
      "address4": "Ejemplo: NY",
      "postcode": "Ejemplo: 10001",
      "notes": "Ejemplo: Dirección de la oficina principal"
    },
    "useAsDefault": "Usar como predeterminada",
    "submitInsert": "Agregar",
    "submitUpdate": "Actualizar",
    "deleteAddress": "Eliminar",
    "deleteAddressAlert": "¿Eliminar esta dirección?",
    "insertSuccessToast": "Dirección agregada",
    "insertFailToast": "No se pudo agregar la dirección",
    "editSuccessToast": "Dirección actualizada",
    "editFailToast": "No se pudo actualizar la dirección",
    "deleteSuccessToast": "Dirección eliminada",
    "deleteFailToast": "No se pudo eliminar la dirección"
  },
  "format": "Formato: {formats} | Formatos: {formats}",
  "isRequired": "{fieldName} es obligatorio",
  "mustBeWholeNum": "{fieldName} debe ser un número entero",
  "mustBeNum": "{fieldName} debe ser un número",
  "mustBeTwoDecimalPlaces": "{fieldName} debe tener 2 dígitos decimales o menos",
  "equalTo": "Igual a",
  "equalGreaterThan": "Mayor o igual que",
  "equalLessThan": "Menor o igual que",
  "greaterThan": "Mayor que",
  "lessThan": "Menor que",
  "isNull": "Está vacío",
  "isNotNull": "No está vacío",
  "isOneOf": "Es uno de",
  "isNotOneOf": "No es uno de",
  "between": "Entre",
  "contains": "Contiene",
  "flightDate": "Fecha del vuelo",
  "flightNumber": "Número de vuelo",
  "holdOff": "Tiempo de espera",
  "complete": "Completar {section}",
  "sendConfirmation": {
    "submit": "Enviar",
    "title": "Enviar confirmación",
    "otherEmail": "Otro correo electrónico",
    "emailErrorText": "Selecciona o ingresa un correo electrónico válido"
  },
  "tariff": {
    "viewOnlyMessage": "Llámanos para reservar este servicio",
    "unavailableMessage": "Selecciona un servicio disponible",
    "unavailableRibbonMessage": "Llamar para reservar",
    "bookMessage": "Reservar - {tariff}",
    "sortLabel": "Ordenar tarifas por"
  },
  "stops": {
    "accordionHeader": "Detalles",
    "asDirectedLabel": "Según indicaciones",
    "missingAddressStopMessage": "Falta la parada"
  },
  "vouchers": {
    "vouchersAddedCount": "1 cupón agregado | {count} cupones agregados",
    "maxVouchersMessage": "Se puede agregar un máximo de {maxVouchers} cupones",
    "addVoucherButton": "Agregar cupón",
    "noVouchersMessage": "No hay cupones agregados",
    "voucherNumber": "Cupón n.º {num}",
    "voucherCode": "Código: {voucherCode}",
    "enterVoucherCode": "Ingrese el código del cupón"
  },
  "arriveByAwaitingDetailsMessage": "Completa los datos de la reserva para ver la hora de llegada",
  "goodButtons": {
    "copy": "Copiar {good}",
    "remove": "Quitar {good}",
    "add": "Agregar {good}"
  },
  "maxGoodsQtyMessage": "La cantidad total de toda la mercancía no puede superar {max}",
  "maxGoodsCartonsMessage": "El total de cajas de toda la mercancía no puede superar {max}",
  "quickQuoteBookingMessage": "Para completar tu reserva, inicia sesión o crea una cuenta de {app}",
  "termsAndConditions": {
    "message": "Al realizar esta reserva, aceptas los",
    "link": "términos y condiciones de reserva",
    "afterMessage": ""
  },
  "cancelBooking": {
    "submit": "Cancelar",
    "otherReason": "Otro motivo",
    "message": "Indica un motivo",
    "reasonErrorText": "Selecciona o ingresa un motivo de cancelación válido"
  }
}
